import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import typographyStyle from 'assets/jss/material-dashboard-pro-react/components/typographyStyle';

// eslint-disable-next-line func-style -- FIXME
function Muted({ ...props }) {
  const { classes, children } = props;
  return (
    <div className={`${classes.defaultFontStyle} ${classes.mutedText}`}>
      {children}
    </div>
  );
}

Muted.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(typographyStyle)(Muted);
